import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";
import { IIconComponent } from "@front/m19-ui";

@Component({
  selector: "app-dropdown-toggle-icon",
  templateUrl: "./dropdown-toggle-icon.component.html",
  styleUrls: ["./dropdown-toggle-icon.component.scss"],
  imports: [NgClass, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownToggleIconComponent {
  @Input({ required: true })
  expand!: boolean;

  @Input()
  iconClass?: string;

  public iconClassArray() {
    return this.iconClass ? [this.iconClass] : [];
  }
}
